import { PrescriptionSubmitRequest, SearchPrescriptionRequest, RxGatingBlockedAttemptRequest, LogPrescriberConfirmationRequest, GenesisCardAuthorizationRequest } from "../redux/slice/prescription/prescriptionSlice";
import { http } from "./http";
import {
  SUBMIT_PRESCRIPTION_URL,
  SEARCH_PRESCRIPTIONS_URL,
  GET_RX_REQUIRED_OPEN_ACCESS_PRODUCTS_URL,
  SEND_NOTIFICATION_EMAIL_URL,
  LOG_RX_GATING_BLOCKED_ATTEMPT_URL,
  LOG_PRESCRIBER_CONFIRMATION_URL,
  GET_GENESIS_INTAKE_RECORD_URL,
  PREVIEW_GENESIS_CARD_AUTHORIZATION_URL,
  GET_RX_AGREEMENT_PRACTICE_LOOKUP_URL,
} from "./URL";

export const submitPrescriptionService = async (request: PrescriptionSubmitRequest, headers: Record<string, string>) => {
  try {
    const response = await http.post(`${SUBMIT_PRESCRIPTION_URL}`, request, { headers: { ...headers } });
    return response;
  } catch (error) {
    throw error;
  }
};

export const searchPrescriptionsService = async (data: SearchPrescriptionRequest, skipLoader: boolean = false) => {
  try {
    const response = await http.post(`${SEARCH_PRESCRIPTIONS_URL}`, data, {
      headers: { 'x-skip-loader': skipLoader.toString() },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getRxRequiredOpenAccessProductsService = async (skipLoader: boolean = false) => {
  try {
    const response = await http.get(`${GET_RX_REQUIRED_OPEN_ACCESS_PRODUCTS_URL}`, {
      headers: { 'x-skip-loader': skipLoader.toString() },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getRxAgreementPracticeLookupService = async (
  productIds: number[],
  skipLoader: boolean = true
) => {
  try {
    let url = `${GET_RX_AGREEMENT_PRACTICE_LOOKUP_URL}`;
    if (productIds.length > 0) {
      url += `?productIds=${productIds.join(",")}`;
    }
    const response = await http.get(url, {
      headers: { "x-skip-loader": skipLoader.toString() },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const sendNotificationEmailService = async (providerId: number | undefined, practiceId: number, skipLoader: boolean = true) => {
  try {
    const response = await http.get(`${SEND_NOTIFICATION_EMAIL_URL}`, {
      params: { providerId, practiceId },
      headers: { 'x-skip-loader': skipLoader.toString() },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

/** CS-2073 — Persist Gate 1 blocked ship-to attempts to the backend audit trail. */
export const logRxGatingBlockedAttemptService = async (
  request: RxGatingBlockedAttemptRequest,
  skipLoader: boolean = true
) => {
  const response = await http.post(LOG_RX_GATING_BLOCKED_ATTEMPT_URL, request, {
    headers: { "x-skip-loader": skipLoader.toString() },
  });
  return response;
};

/** CS-2073 — Persist Gate 2 prescriber confirmation acknowledgment to the audit trail. */
export const logPrescriberConfirmationService = async (
  request: LogPrescriberConfirmationRequest,
  skipLoader: boolean = true
) => {
  const response = await http.post(LOG_PRESCRIBER_CONFIRMATION_URL, request, {
    headers: { "x-skip-loader": skipLoader.toString() },
  });
  return response;
};

/** CS-2075 — Live Genesis intake JSON for the list Response JSON action. */
export const getGenesisIntakeRecordService = async (
  prescriptionId: number,
  skipLoader: boolean = false
) => {
  const response = await http.get(`${GET_GENESIS_INTAKE_RECORD_URL}/${prescriptionId}`, {
    headers: { "x-skip-loader": skipLoader.toString() },
  });
  return response;
};

/** CS-2075 — Genesis card authorization template filled with the Fill Up popup values. */
export const previewGenesisCardAuthorizationService = async (
  request: GenesisCardAuthorizationRequest,
  skipLoader: boolean = false
) => {
  const response = await http.post(PREVIEW_GENESIS_CARD_AUTHORIZATION_URL, request, {
    headers: { "x-skip-loader": skipLoader.toString() },
  });
  return response;
};
